/**
 * Carrossel de depoimentos da loja (Konfidency).
 * @see https://docs.konfidency.com.br/docs/konfidency-reviews/storefront/javascript/store-carousel/
 */
export default function StoreReviewCarousel() {
    return (
        <section className='px-4 mx-auto max-w-[1770px] pt-8'>
            <div className='konfidency-storeReviewCarousel' />
        </section>
    )
}

export function LoadingFallback() {
    return (
        <section className='px-4 mx-auto max-w-[1770px] py-8 lg:py-12'>
            <div className='h-[280px] w-full rounded-xl bg-neutral-100 animate-pulse' />
        </section>
    )
}
